import type React from 'react';

import { TranslatePlural } from '@change-corgi/core-react/i18n';
import { Text } from '@change-corgi/design-system-legacy/typography';

import { usePetitionSignatureCount } from '../../../hooks/petitionStats';

export const SignatureStatsClosedContainer: React.FC = () => {
	const { signatureCount } = usePetitionSignatureCount();

	return (
		<Text color="typography-secondary">
			<TranslatePlural
				value="fe.pages.petition_show.num_supporters_closed"
				replacements={{
					num_sigs: signatureCount.displayedLocalized,
				}}
				count={signatureCount.displayed}
			/>
		</Text>
	);
};
